import { FC, useCallback } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import FloatingPaneNotification from 'components/features/pfm/FloatingPaneNotification/FloatingPaneNotification'
import { resetPostFutureLayerErrorActionCreator } from 'components/features/future/actions'
import { resolveErrorById } from 'constants/errors'
import { FutureLayerType } from 'components/features/future/types'


type FuturePaneOverlayProps = {
  type: FutureLayerType
  onDismiss?: () => void
}
export const FuturePaneOverlay: FC<FuturePaneOverlayProps> = (props) => {
  const { type, onDismiss } = props

  const errorMessage = useStoreSelector((state) => {
    const { isLoading, errorCode, errorsMap } = state.data.future.layerPostRequest

    if (!errorCode || isLoading || !errorsMap || !errorsMap['non_field_errors']) {
      return null
    }

    const error = errorsMap['non_field_errors'][0] || `Can't perform action`
    return resolveErrorById(error as any, type)
  })

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    !!onDismiss && onDismiss()
    dispatch(resetPostFutureLayerErrorActionCreator())
  }, [dispatch, onDismiss])

  if (errorMessage === null) {
    return null
  }

  return (
    <FloatingPaneNotification onDismiss={ handleClose } style='solid'>
      { errorMessage }
    </FloatingPaneNotification>
  )
}
